(() => {
  function closeMenus(event) {
    const header = document.querySelector('.xz-header');
    if (!header) return;
    if (event.type === 'keydown' && event.key !== 'Escape') return;
    header.querySelectorAll('details[open]').forEach(details => {
      if (event.type === 'keydown' || !details.contains(event.target)) {
        details.open = false;
        if (event.type === 'keydown') details.querySelector('summary').focus();
      }
    });
  }
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
})();
